import { render, staticRenderFns } from "./RepairItemCard.vue?vue&type=template&id=a49822f6"
import script from "./RepairItemCard.vue?vue&type=script&lang=js"
export * from "./RepairItemCard.vue?vue&type=script&lang=js"
import style0 from "./RepairItemCard.vue?vue&type=style&index=0&id=a49822f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports